import { render, staticRenderFns } from "./ThresholdController.vue?vue&type=template&id=38764c6e&scoped=true&"
import script from "./ThresholdController.vue?vue&type=script&lang=js&"
export * from "./ThresholdController.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdController.vue?vue&type=style&index=0&id=38764c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38764c6e",
  null
  
)

export default component.exports